export const parseErrorMessages = (errorResponse) => {
    return Object.entries(errorResponse?.data?.errors || {})
        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
        .join('. ');
};
